import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

//const BaseUrl = "https://6tofw2oy35dsvpq7ydvbzq37m4.appsync-api.eu-west-1.amazonaws.com/graphql";
const BaseUrl = "https://2sqp5bi3nvhltmaqnx44bohmo4.appsync-api.eu-west-1.amazonaws.com/graphql";

export async function getUrl(selected, campos, effectiveIsReportRecovery, isReportBankReader, isReportPromotion, isReportPaymentsPlans, isVisibleTypeProduct, isVisibleRealEndDate, isVisiblePolicyType, isVisibleNumberFees) {
    const dateFormater = (date) => {
        if (date && date.includes('/')) {
            const parts = date.split('/');
            // Convertir DD/MM/YYYY a YYYY-MM-DD
            return parts[2] + '-' + parts[1].padStart(2, '0') + '-' + parts[0].padStart(2, '0');
        }
        return date;
    };

    const jsonFormater = (json) => {
        for (let i in json) {
            if (json[i] == false) {
                delete json[i]
            } else if (Object.entries(json[i]).length > 0) {
                jsonFormater(json[i])
            }
            if (json[i] != undefined && json[i] != null) {
                if (Object.entries(json[i]).length < 1 && json[i] != true) {
                    delete json[i]
                }
            }
        }
        return json
    }

    let filter = "{}";

    if (selected != null && selected != undefined && selected != '') {
        let filtros = selected;

        // Formatear fechas
        if (filtros.dateFrom) {
            filtros.dateFrom = filtros.dateFrom.toString() == "[object Object]" ? null : dateFormater(filtros.dateFrom);
        }
        if (filtros.dateTo) {
            filtros.dateTo = filtros.dateTo.toString() == "[object Object]" ? null : dateFormater(filtros.dateTo);
        }
        if (filtros.realEndDateFrom) {
            filtros.realEndDateFrom = filtros.realEndDateFrom.toString() == "[object Object]" ? null : dateFormater(filtros.realEndDateFrom);
        }
        if (filtros.realEndDateTo) {
            filtros.realEndDateTo = filtros.realEndDateTo.toString() == "[object Object]" ? null : dateFormater(filtros.realEndDateTo);
        }

        // Limpiar campos vacíos
        for (var campo in filtros) {
            if (filtros[campo] == "" || filtros[campo] == null || Object.entries(filtros[campo]).length == 0) {
                delete filtros[campo]
            }
        }

        // Construir filtro de forma más robusta
        let filterParts = [];

        // Campos directos
        if (filtros.contractId != undefined) {
            filterParts.push(`contractId: "${filtros.contractId}"`);
        }
        if (filtros.dateFrom != undefined) {
            filterParts.push(`dateFrom: "${filtros.dateFrom}"`);
        }
        if (filtros.dateTo != undefined) {
            filterParts.push(`dateTo: "${filtros.dateTo}"`);
        }
        if (filtros.realEndDateFrom != undefined) {
            filterParts.push(`realEndDateFrom: "${filtros.realEndDateFrom}"`);
        }
        if (filtros.realEndDateTo != undefined) {
            filterParts.push(`realEndDateTo: "${filtros.realEndDateTo}"`);
        }
        // Estados: uno => status, varios => statuses (enums sin comillas, nunca ambos)
        if (filtros.status != undefined) {
            const statuses = String(filtros.status).split(',').map(s => s.trim()).filter(Boolean);
            if (statuses.length === 1) {
                filterParts.push(`status: ${statuses[0]}`);
            } else if (statuses.length > 1) {
                filterParts.push(`statuses: [${statuses.join(', ')}]`);
            }
        }
        if (filtros.tenant != undefined) {
            filterParts.push(`tenant: "${filtros.tenant}"`);
        }

        // Customer object - solo agregar si hay campos
        let customerParts = [];
        if (filtros.email != undefined) {
            customerParts.push(`email: "${filtros.email}"`);
        }
        if (filtros.name != undefined) {
            customerParts.push(`name: "${filtros.name}"`);
        }
        if (filtros.legalIdentifier != undefined) {
            customerParts.push(`legalIdentifier: "${filtros.legalIdentifier}"`);
        }
        if (filtros.phone != undefined) {
            customerParts.push(`phone1: "${filtros.phone}"`);
        }
        if (filtros.surnames != undefined) {
            customerParts.push(`surnames: "${filtros.surnames}"`);
        }
        if (filtros.reasonAccepted != undefined) {
            customerParts.push(`line: { scoringFlags: { reasonAccepted: "${filtros.reasonAccepted}" } }`);
        }

        if (customerParts.length > 0) {
            filterParts.push(`customer: {${customerParts.join(', ')}}`);
        }

        // Branch object - solo agregar si hay campos
        let branchParts = [];
        if (filtros.storeNumber != undefined) {
            branchParts.push(`storeNumber: "${filtros.storeNumber}"`);
        }

        if (branchParts.length > 0) {
            filterParts.push(`branch: {${branchParts.join(', ')}}`);
        }

        // Campos booleanos (sin comillas)
        filterParts.push(`isReportRecovery: ${effectiveIsReportRecovery ? 'false' : 'true'}`);
        filterParts.push(`isReportBankReader: ${isReportBankReader}`);
        filterParts.push(`isReportPromotion: ${isReportPromotion}`);
        filterParts.push(`isReportPaymentsPlans: ${isReportPaymentsPlans}`);
        filterParts.push(`isVisibleTypeProduct: ${isVisibleTypeProduct}`);
        filterParts.push(`isVisibleRealEndDate: ${isVisibleRealEndDate}`);
        filterParts.push(`isVisiblePolicyType: ${isVisiblePolicyType}`);
        filterParts.push(`isVisibleNumberFees: ${isVisibleNumberFees}`);

        // Construir filtro final
        filter = `{${filterParts.join(', ')}}`;
    }

    // Procesar campos
    if (campos != null) {
        console.log('Campos originales:', JSON.stringify(campos, null, 2));
        const camposLimpios = jsonFormater(JSON.parse(JSON.stringify(campos)));
        console.log('Campos después de jsonFormater:', JSON.stringify(camposLimpios, null, 2));
        campos = JSON.stringify(camposLimpios).replaceAll(':', '').replaceAll('"', '').replaceAll('true', '').slice(0, -1).slice(1);
    }

    console.log('Filter generado:', filter);
    console.log('Campos generados:', campos);
    console.log('Query completa:', "query ExtractionQuery {contractExport(filter:" + filter + ") { downloadLink fieldsToExtract {" + campos + " }}}");

    return axios({
        method: "post",
        data: { query: "query ExtractionQuery {contractExport(filter:" + filter + ") { downloadLink fieldsToExtract {" + campos + " }}}" },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${BaseUrl}`,
        withCredentials: false,
    });
}

export async function getProductUrl(filters) {
    let filterParts = [];

    if (filters && typeof filters === 'object') {
        if (filters.brand) filterParts.push(`brand: "${filters.brand}"`);
        if (filters.model) filterParts.push(`model: "${filters.model}"`);
        if (filters.color) filterParts.push(`color: "${filters.color}"`);
        if (filters.capacity) filterParts.push(`capacity: "${filters.capacity}"`);
    }

    const filter = filterParts.length > 0 ? `{${filterParts.join(', ')}}` : '{}';

    return axios({
        method: "post",
        data: { query: `query ExtractionQuery { productExport(filter: ${filter}) { downloadLink } }` },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `${BaseUrl}`,
        withCredentials: false,
    });
}

const apiCSV = {
    getUrl,
    getProductUrl
};
export default apiCSV;